(function () {
    'use strict';

    angular
        .module('SodCustomAction')
        .directive('sodStaticNotifier', sodStaticNotifier);

    function sodStaticNotifier() {
        return {
            restrict :'E',
            scope: {
            },
            controller: sodStaticNotifierCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/components/notifier/static-notifier'
        };
    }

    function sodStaticNotifierCtrl(ActionModel, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.name = $scope.$parent.vm.fbData.name;

            ActionModel.sync(vm, 'static-notifier', vm.name);

            $scope.$on('$destroy', function() {
                ActionModel.destroy('static-notifier', vm.name);
            });
        }
    }
})();